
var Model = require("../types/Model.js");

module.exports = new Model({
	name: "screenhider",
	init: init,
	triggers: triggers,
	listeners: listeners
});

function init() {
	this.push(false);
}

function triggers() {
	return {
		hide: hide,
		show: show
	};
}

function listeners() {
	return {
		"buzz:state:calling": show,
		"buzz:state:receiving": show,
		"activereminder:active": show,
		"unreadnotifications:newmessage": show,
		"activeworkflowaction:viewing": show,
	};
}

function hide() {
	if (!this.data) this.push(true);
}

function show() {
	if (this.data) this.push(false);
}